import { z } from "zod";

export const TaskGroupCreateSchema = z.object({
    name: z.string().min(1, { message: "Required" }).max(255),
});

export type TaskGroupCreate = z.infer<typeof TaskGroupCreateSchema>;

export const TaskGroupUpdateSchema = z.object({
    name: z.string().min(1).max(255),
});

export type TaskGroupUpdate = z.infer<typeof TaskGroupUpdateSchema>;
